"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.map.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _BarChart = _interopRequireDefault(require("../BarChart.vue"));
var _report = require("@/api/report.api");
var ProfitChart = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(ProfitChart, _Vue);
  var _super = (0, _createSuper2.default)(ProfitChart);
  function ProfitChart() {
    var _this;
    (0, _classCallCheck2.default)(this, ProfitChart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "date", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "orderType", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "xAxisValue", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "legend", ["Doanh thu", "Lợi nhuận"]);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "series", []);
    return _this;
  }
  (0, _createClass2.default)(ProfitChart, [{
    key: "watchDate",
    value: function watchDate() {
      this.fetchData();
    }
  }, {
    key: "watchOrderType",
    value: function watchOrderType() {
      this.fetchData();
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var query, res, data, series;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = {
                  date: this.date.to,
                  orderType: this.orderType
                };
                _context.next = 3;
                return _report.reportApi.profitChart(query);
              case 3:
                res = _context.sent;
                data = res.data;
                series = [];
                series.push({
                  name: "Doanh thu",
                  type: "bar",
                  barGap: 0,
                  // label: labelOption,
                  emphasis: {
                    focus: "series"
                  },
                  itemStyle: {
                    color: "#3066d0"
                  },
                  data: data.map(function (e) {
                    return e.sale;
                  })
                });
                series.push({
                  name: "Lợi nhuận",
                  type: "bar",
                  barGap: 0,
                  itemStyle: {
                    color: "#d53e0a"
                  },
                  emphasis: {
                    focus: "series"
                  },
                  data: data.map(function (e) {
                    return e.profit;
                  })
                });
                this.series = series;
                this.xAxisValue = data.map(function (e) {
                  return e.date;
                });
                _context.next = 12;
                return this.$nextTick();
              case 12:
                this.$refs.chart.initChart();
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
  return ProfitChart;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProfitChart.prototype, "date", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProfitChart.prototype, "orderType", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("date", {
  immediate: true
})], ProfitChart.prototype, "watchDate", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("orderType")], ProfitChart.prototype, "watchOrderType", null);
ProfitChart = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    BarChart: _BarChart.default
  }
})], ProfitChart);
var _default = ProfitChart;
exports.default = _default;